
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';
import sellerSearchTpl from '!!file-loader?name=templates/[name].[ext]!./sellerSearch.html';

/**
 * Directive used for manipulate the HTML DOM elements inside the sellerCashierSearch component
 */
function sellerSearchComponent() {

	/**
	 * Directive definition
	 */
	const directive = {
		restrict: 'E',
		templateUrl: sellerSearchTpl,
		controller: SellerSearchController,
		controllerAs: 'sellersearchvm',
		bindToController: true,
		scope: {
			reciver: '=',
			clearComponents: '&'
		}
	};

	return directive;

	function SellerSearchController(utilitiesConstant, utilitiesFactory, restClientServices, sessionFactory, sellerSearchConstant) {
		'ngInject';

		/**
		 * Scope for manipulated data in HTML DOM elements.
		 */
		const user = angular.fromJson(sessionFactory.get(utilitiesConstant.STORAGE.USER));
		let vm = this;
		vm.searchSellerText = '';
		vm.sellers = [];
		vm.constant = sellerSearchConstant;

		/**
		 * Filters sellers by name and username
		 */
		vm.searchSeller = searchText => vm.sellers.filter(seller => _.includes(seller.name.toLowerCase(), searchText.toLowerCase()) || _.includes(seller.identification, searchText));

		(function () {
			/**
			 * Gets sellers from the server
			 */
			const sellersCashiersUrl = utilitiesConstant.URL_ENDPOINT_GANA.concat(utilitiesConstant.URL_API_METHOD.SELLERS_CASHIERS);

			restClientServices.ganaService(sellersCashiersUrl, { userId: user.office.code })
				.then(response => {
					vm.sellers = response.sellers;
				},
				error => {
					if (error.status === 404) {
						utilitiesFactory.showAlertMessage(sellerSearchConstant.NOT_FOUND_SELLERS);
					} else {
						utilitiesFactory.showErrorMessage(utilitiesConstant.MSG_ERROR);
					}
				});
		})();
	}
}

export default sellerSearchComponent;



// WEBPACK FOOTER //
// ./src/app/core/components/sellerSearch/sellerSearch.directive.js